import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
    current: {},
    currentLoading: false,
    limits: {},
    limitsLoading: false,
    athletesAssociationCount: 0,
    athletesAssociationCountLoading: false,
    associationsList: [],
    associationsListLoading: false,
    entriesListLoading: false,
    entriesList: []
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setCurrent(state, payload) {
      state.current = payload;
    },
    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    },
    setLimits(state, payload) {
      state.limits = payload;
    },
    setLimitsLoading(state, payload) {
      state.limitsLoading = payload;
    },
    setAthletesAssociationCount(state, payload) {
      state.athletesAssociationCount = payload;
    },
    setAthletesAssociationCountLoading(state, payload) {
      state.athletesAssociationCountLoading = payload;
    },
    setAssociationsList(state, payload) {
      state.associationsList = payload;
    },
    setAssociationsListLoading(state, payload) {
      state.associationsListLoading = payload;
    },
    setEntriesListLoading(state, payload) {
      state.entriesListLoading = payload;
    },
    setEntriesList(state, payload) {
      state.entriesList = payload;
    }
  },
  actions: {
    async loadAll({ commit, rootState }) {
      commit("setListLoading", true);
      let list = await api.get("competitions", {
        params: {
          entries: rootState.settings.siteArea == "Entries" ? true : null
        }
      });
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setCurrentLoading", true);
      let response = await api.get("competitions/byID", { params: { id: id } });
      commit("setCurrent", response.data[0]);
      commit("setCurrentLoading", false);
    },
    async loadLimits({ commit }, id) {
      commit("setLimitsLoading", true);
      let response = await api.get("competitions/byID/limits", {
        params: { id: id }
      });
      commit("setLimits", response.data);
      commit("setLimitsLoading", false);
    },
    async updateLimit({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("competitions/limits/update", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadLimits", payload.competitions_id);
      return returnData;
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("competitions", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`competitions`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadByID", payload.id);
      dispatch("loadAll");
      return returnData;
    },
    async archive({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("competitions/archive", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async unArchive({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("competitions/unArchive", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async delete({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("competitions/delete", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async loadAthletesForAssociationCount({ commit }, payload) {
      commit("setAthletesAssociationCountLoading", true);
      let response = await api.get("competitions/athletesForAssociationCount", {
        params: payload
      });
      commit("setAthletesAssociationCount", response.data);
      commit("setAthletesAssociationCountLoading", false);
    },
    async loadAssociations({ commit }, competitions_id) {
      console.log(competitions_id);
      commit("setAssociationsListLoading", true);
      let response = await api.get("competitions/associations", {
        params: { competitions_id: competitions_id }
      });
      commit("setAssociationsList", response.data);
      commit("setAssociationsListLoading", false);
    },
    async loadAllEntries({ commit }, competitions_id) {
      commit("setEntriesListLoading", true);
      let response = await api.get("competitions/entries", {
        params: { competitions_id: competitions_id }
      });
      commit("setEntriesList", Object.values(response.data));
      commit("setEntriesListLoading", false);
    },

    async duplicate({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("competitions/duplicate", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },

    async sendInvoiceToAssociations({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("xero/sendInvoice", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async updateOmega({ commit, rootState }, id) {
      api.get("omega/createOmegaFilesForCompetition", {
        params: {
          id: id
        }
      });
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLive(state) {
      return state.list
        .filter(c => c.status != "DRAFT")
        .sort((a, b) => {
          return new Date(a.start_date) - new Date(b.start_date);
        });
    },
    listActive(state) {
      return state.list.filter(c => !c.archived_at);
    },
    listLoading(state) {
      return state.listLoading;
    },
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    },
    limits(state) {
      return state.limits;
    },
    limitsLoading(state) {
      return state.limitsLoading;
    },
    athletesAssociationCount(state) {
      return state.athletesAssociationCount;
    },
    athletesAssociationCountLoading(state) {
      return state.athletesAssociationCountLoading;
    },
    associationsList(state) {
      return state.associationsList;
    },
    associationsListLoading(state) {
      return state.associationsListLoading;
    },
    entriesListLoading(state) {
      return state.entriesListLoading;
    },
    entriesList(state) {
      return state.entriesList;
    }
  }
};
